module.exports = __webpack_public_path__ + "static/media/info.2a50b10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/tfsinspection/info.png
// module id = 226
// module chunks = 0